import { createRef } from 'react';

export const mySharedRef = createRef();